import axios from "axios";

const BaseUrl =
  `${process.env.REACT_APP_API_URL.replace(/\/+$/, "")}/`;

export const endpoints = {
  Store: "Store",
  StorePrinter: "StorePrinter",
  User: "User",
  Product: "Product",
  Purchase: "Purchase",
  
  Supplier: "Supplier",
  Customer: "Customer",
  CustomerPayment: "CustomerPayment",

  ExpenseCat: "ExpenseCat",
  Expense: "Expense",
  Auth: "Auth",
  PurchReturn: "PurchReturn",
  Category: "Category",
  Inventory: "Inventory",
  Salary: "Salary",
  StockTrans: "StockTrans",
  PosItem: "PosItem",
  Sell: "Sell",
  VoidSell: "VoidSell",
  Register: "Register",
  Companies: "Companies", // ✅ ADD
};

export const controller = {
  GetById: "/GetById",
  GetAuthUser: "/GetAuthUser",
  CheckUserName: "/CheckUserName",
  Login: "/Login",
  Logout: "/Logout",
  Forgot: "/Forgot",
  SetDefStore: "/SetDefStore",
  GetDefStore: "/GetDefStore",
  GetProductByBarcode: "/GetProductByBarcode",
  GetAllEmployees: "/GetAllEmployees",
  GetProdsByStore: "/GetProdsByStore",
  FindProducts: "/FindProducts",
  FindCategories: "/FindCategories",
  GetByStoreId: "/GetByStoreId",
  GetByStore: "/GetByStore",
  GetDefaultPrinter: "/GetDefaultPrinter",
  GetByBarcode: "/GetByBarcode",
  GetProdsByCat: "/GetProdsByCat",
  GetLastSell: "/GetLastSell",
  GetRefundableById: "/GetRefundableById",
  GetSellsByStore: "/GetSellsByStore",
  GetCatsByStore: "/GetCatsByStore",
  CloseRegSells: "/CloseRegSells",
  PostCancelCart: "/PostCancelCart",
  StoreReport: "/StoreReport",
  GetRegsByStore: "/GetRegsByStore",
  GetCancelCartsByStore: "/GetCancelCartsByStore",
  AvailableInStock: "/AvailableInStock",
  GetCompanyName: "/GetCompanyName", // ✅ ADD

  GetCustomerAccount: "/Account", // ✅ ADD
  CustomerBalanceReport: "/BalanceReport", // ✅ ADD
};


export const api = (endpoint) => {
  const url = BaseUrl + endpoint; // ✅ no trailing slash

  return {
    get: () => axios.get(url, { withCredentials: true }),

    getById: (id) =>
      axios.get(`${url}/${id}`, { withCredentials: true }), // ✅ FIX

    getByObj: (obj) =>
      axios.post(url, obj, { withCredentials: true }),

    post: (data) =>
      axios.post(url, data, { withCredentials: true }),

    put: (data) =>
      axios.put(url, data, { withCredentials: true }),

    delete: (id) =>
      axios.delete(`${url}/${id}`, { withCredentials: true }), // ✅ FIX
  };
};